<div>
    <section class="table-scroll">
        <table mat-table [dataSource]="dataSource" matSort
        multiTemplateDataRows  
        style="border-radius: 10px; margin-bottom: 1rem;" class="mat-elevation-z8 table-scroll">
            <ng-container matColumnDef="priority">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                    Prioridad
                </th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.priority}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                    Nombre
                </th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.name}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="enabled">
                <th mat-header-cell *matHeaderCellDef>
                    Habilitado
                </th>
                <td mat-cell *matCellDef="let element">
                    <i-tabler
                    [ngStyle]="{color: element.enabled ? 'green' : 'red'}"
                    class="theme-icon"
                    name="{{element.enabled ? 'circle-check' : 'xbox-x'}}">
                    </i-tabler>
                </td>
            </ng-container>

            <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button aria-label="expand-row">
                        <mat-icon>
                            {{selectedMinuteApprovalRuleId != null && selectedMinuteApprovalRuleId === element.minuteRequestApprovalRuleId
                                ? "keyboard_arrow_up" : "keyboard_arrow_down"
                            }}
                        </mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="tableColumns?.length">
                    <div  [@rowExpand]="selectedMinuteApprovalRuleId === element.minuteRequestApprovalRuleId ? 'expanded' : 'collapsed'" 
                        class="example-element-detail">
                        <section *ngIf="selectedMinuteApprovalRuleId === element.minuteRequestApprovalRuleId">
                            <ng-content></ng-content>
                        </section>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr class="example-element-row"
                mat-row *matRowDef="let row; columns: tableColumns" 
               [cdkContextMenuTriggerFor]="minuteApprovalContext" 
                (click)="toggleMinuteApprovalRule(row.minuteRequestApprovalRuleId)"
                [class.example-expanded-row]="selectedMinuteApprovalRuleId === row.minuteRequestApprovalRuleId">
                <ng-template #minuteApprovalContext>
                    <div class="context-menu-rule" cdkMenu>
                        <button [disabled]="!canEnableDisableRule" class="menu-item" cdkMenuItem mat-raised-button (click)="clickEnableOrDisableMinuteApprovalRule(row)">
                            {{row.enabled ? 'Inhabilitar' : 'Habilitar'}}
                        </button>
                        <button [disabled]="!canUpdateRule" class="menu-item" cdkMenuItem mat-raised-button (click)="clickUpdateMinuteApprovalRule(row)">
                            Modificar
                        </button>
                    </div>
                </ng-template>
            </tr>
            <tr mat-row *matRowDef="let row; columns:['expandedDetail']" class="example-detail-row"></tr>
        </table>
    </section>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
</div>


